import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, Paper, IconButton, Collapse, Divider, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Info, Close, HelpOutline, ArrowRight } from '@mui/icons-material';
import { getTranslation } from '../../i18n';
import { LIGHTNING_RECENT, LIGHTNING_MEDIUM, LIGHTNING_OLD } from '../../constants/mapIcons';

const InfoCard = ({ isOpen, onClose }) => {
  const { language } = useSelector((state) => state.ui);
  const translations = getTranslation(language);
  const t = translations.map;

  // Legend items with icon paths and descriptions
  const legendItems = [
    {
      icon: LIGHTNING_RECENT,
      description: t.recent,
    },
    {
      icon: LIGHTNING_MEDIUM,
      description: t.medium,
    },
    {
      icon: LIGHTNING_OLD,
      description: t.old,
    },
  ];

  return (
    <Collapse in={isOpen} timeout="auto" unmountOnExit>
      <Paper 
        className="info-card"
        elevation={3}
        sx={{
          position: 'absolute',
          bottom: 24,
          left: 16,
          padding: 2,
          borderRadius: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          maxWidth: 300,
          zIndex: 1000,
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography variant="subtitle1" component="div" sx={{ display: 'flex', alignItems: 'center' }}>
            <Info fontSize="small" sx={{ mr: 1 }} />
            {t.legend}
          </Typography>
          <IconButton size="small" onClick={onClose} aria-label="close">
            <Close fontSize="small" />
          </IconButton>
        </Box>

        {legendItems.map((item, index) => (
          <Box key={index} className="legend-item" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <img 
              src={item.icon} 
              alt="Legend icon" 
              className="legend-icon"
              style={{ width: 24, height: 24, marginRight: 8 }}
            />
            <Typography variant="body2">
              {item.description}
            </Typography>
          </Box>
        ))}

        <Divider sx={{ my: 2 }} />

        {/* Help Section */}
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" component="div" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <HelpOutline fontSize="small" sx={{ mr: 1 }} />
            {t.helpTitle}
          </Typography>

          <List dense disablePadding>
            <ListItem disableGutters sx={{ py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 24 }}>
                <ArrowRight fontSize="small" color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary={t.helpText1} 
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
            <ListItem disableGutters sx={{ py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 24 }}>
                <ArrowRight fontSize="small" color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary={t.helpText2} 
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
            <ListItem disableGutters sx={{ py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 24 }}>
                <ArrowRight fontSize="small" color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary={t.helpText3} 
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
          </List>
        </Box>
      </Paper>
    </Collapse>
  );
};

export default InfoCard;
